<template>
  <div>
    <!-- 搜索筛选 -->
    <div class="query-select">
      <el-form :inline="true" :model="queryParams" class="user-search">
        <el-form-item label="考生姓名：">
          <el-input
            size="small"
            v-model="queryParams.name"
            placeholder="输入考生姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="考试名称：">
          <el-select
            @change="getTableList"
            clearable
            v-model="queryParams.examinationName"
            size="small"
            placeholder="请选择"
          >
            <el-option
              :label="item.examName"
              :value="item.examName"
              v-for="(item, index) in classData"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试开始时间：">
          <el-date-picker
            @change="dateChange"
            size="small"
            v-model="dateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            placeholder="选择时间"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          size="small"
          round
          @click="getTableList"
          >查询</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-refresh-left"
          plain
          size="small"
          round
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          type="success"
          icon="el-icon-plus"
          plain
          size="small"
          round
          @click="dialogOpen('add')"
        >
          新增
        </el-button>
        <el-button
          type="success"
          icon="el-icon-upload2"
          plain
          size="small"
          round
          @click="uploadOpen"
          >导入</el-button
        >
      </div>
    </div>
    <!--列表-->
    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        border
        stripe
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 85vw"
      >
        <el-table-column align="center" type="index" width="60">
        </el-table-column>
        <el-table-column
          align="center"
          prop="memberCode"
          label="考号"
          width="180"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="考生姓名"
          width="180"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="courseLevel"
          label="等级"
          width="180"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ getExamLabel(scope.row.courseLevel) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="examinationName"
          label="考试名称	"
          min-width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="examinationStartTime"
          label="考试开始日期	"
          width="200"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{
              getMinTime(
                scope.row.theoryStartTime,
                scope.row.practicalExamStartTime
              )
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机号	"
          width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="idCard"
          label="身份证号	"
          min-width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <!-- <el-button
              plain
              size="mini"
              round
              type="warning"
              @click="dialogOpen('edit', scope.row)"
              >编辑</el-button
            > -->
            <el-button
              plain
              size="mini"
              round
              type="danger"
              @click="deleteClick(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>

    <StudentDialog
      ref="studentDialogRef"
      @success="getTableList"
    ></StudentDialog>

    <UploadForm ref="uploadFormRef" @success="getTableList"></UploadForm>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import { getExamAll } from "@/api/exam";
import download from "@/utils/download";
import { tableGet, dataUpload, dataDelete } from "../../api/student";
import { getMinTime } from "@/utils/util";
import StudentDialog from "./StudentDialog.vue";
import UploadForm from "./UploadForm.vue";
import { getExamLabel } from "@/utils/dict.js";

export default {
  data() {
    return {
      values: "",
      totals: 0,
      loading: false, //是显示加载
      listData: [],
      dateRange: [],
      classData: null,
      // 分页参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        examinationName: "",
        name: ""
      }
    };
  },
  // 注册组件
  components: {
    Pagination,
    StudentDialog,
    UploadForm
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getTableList();
    this.getAllTrain();
  },
  mounted() {},
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getExamLabel,
    getMinTime,

    dateChange(val) {
      if (val && val.length > 0) {
        this.queryParams.beginTime = val[0] + " 00:00:00";
        this.queryParams.endTime = val[1] + " 23:59:59";
      }
      this.getTableList();
    },
    resetSelect() {
      this.queryParams.name = "";
      this.queryParams.examinationName = "";
      this.queryParams.examinationName = "";
      this.queryParams.beginTime = "";
      this.queryParams.endTime = "";
      this.dateRange = [];
      this.getTableList();
    },
    // 打开编辑、新增弹框
    dialogOpen(type, row = {}) {
      this.$refs.studentDialogRef.open(type, row);
    },
    uploadOpen() {
      this.$refs.uploadFormRef.uploadVisible = true;
    },

    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getTableList();
    },
    // 获取表格数据
    async getTableList() {
      this.loading = true;
      // const params = tansParams(this.queryParams);

      const res = await tableGet(this.queryParams);
      let result = res.data;
      if (result.code === 200) {
        this.loading = false;
        this.listData = result.data.rows;
        this.totals = result.data.total;
      } else {
        this.loading = false;
      }
    },

    async deleteClick(row) {
      this.$confirm("是否删除该考生?", "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning"
      }).then(() => {
        dataDelete(row.memberExamineeId).then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getTableList();
        });
      });
    },

    async getAllTrain() {
      const res = await getExamAll();
      this.classData = res.data.data;
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/StudentsManage/StudentsManage.vue